import { AREAS } from "@/lib/heat";

export const RATING_SCALE = [
  { short: "Not Present", full: "Not Present / Becoming Aware" },
  { short: "Showing Potential", full: "Showing Potential / Becoming Centered" },
  { short: "Deeply Rooted", full: "Deeply Rooted / Becoming Grounded" },
  { short: "Bearing Fruit", full: "Bearing Fruit / Becoming Secure" },
  { short: "World-Changing Impact", full: "World-Changing Impact / Becoming Love" },
];

const scaleIndex = (label) =>
  RATING_SCALE.findIndex((r) => r.short.toLowerCase() === String(label || "").split("/")[0].trim().toLowerCase());

export const fullRating = (label) => RATING_SCALE[scaleIndex(label)]?.full || label || "—";

export const nextRating = (label) => {
  const i = scaleIndex(label);
  if (i < 0) return "—";
  return i >= RATING_SCALE.length - 1 ? "Keep sustaining World-Changing Impact / Becoming Love" : RATING_SCALE[i + 1].full;
};

const levelOf = (a) => (a.level !== undefined ? Number(a.level) : (Number(a.rate) || 0) / 4);
const areaLabel = (k) => AREAS.find((a) => a.key === k)?.label || k;

export function sortedTopics(answers, questions) {
  if (!answers || !questions?.length) return [];
  return questions
    .filter((q) => answers[q.key])
    .map((q) => {
      const a = answers[q.key];
      const answer = a.label || a.rate_label || "";
      return {
        key: q.key, label: q.label, areas: q.areas || [], areaNames: (q.areas || []).map(areaLabel).join(" & "),
        answer, answerFull: fullRating(answer), next: nextRating(answer), pct: levelOf(a),
      };
    })
    .sort((x, y) => x.pct - y.pct || x.label.localeCompare(y.label));
}

export const topicsByArea = (topics) =>
  AREAS.map((a) => ({ ...a, rows: topics.filter((t) => t.areas.includes(a.key)) }));

export function workbookKeyTopics(topics) {
  const seen = new Set();
  const out = [];
  topicsByArea(topics).forEach((a) => {
    a.rows.slice(0, 2).forEach((t) => {
      if (!seen.has(t.key)) {
        seen.add(t.key);
        out.push(t);
      }
    });
  });
  return out.sort((x, y) => x.pct - y.pct || x.label.localeCompare(y.label));
}
